import {
  FaMap,
  FaCalculator,
  FaChartLine,
  FaHandPointer,
} from "react-icons/fa";

export const MapBtn = (props) => {
  return (
    <>
      <button className="px-2 py-1 f-10px m-btn m-btn-red f-Medium" {...props}>
        <FaMap style={{ margin: "0 .5rem" }} />
        نقشه
      </button>
    </>
  );
};

export const CalcBtn = (props) => {
  return (
    <>
      <button className="px-2 py-1 m-btn m-btn-blue f-10px f-Medium" {...props}>
        <FaCalculator style={{ margin: "0 .5rem" }} />
        محاسبات
      </button>
    </>
  );
};

export const ChartBtn = (props) => (
  <>
    <button className="px-2 py-1 m-btn m-btn-blue f-10px f-Medium" {...props}>
      <FaChartLine style={{ margin: "0 .5rem" }} />
      نمودار تغییرات
    </button>
  </>
);

export const DisableBtn = (props) => (
  <>
    <button className="px-2 py-1 m-btn m-btn-dis f-10px f-Medium" {...props}>
      <FaHandPointer style={{ margin: "0 .5rem" }} />
      روی نقشه کلیک کنید
    </button>
  </>
);
